"use client";

import { c as _c } from "react-compiler-runtime";
import { ResponsiveModal, ResponsiveModalContent, ResponsiveModalTitle } from "@/components/ui/responsive-modal";
import { useTranslation } from "@/core/i18n";
import { ConsentForm, type ConsentFormTranslationKeys } from "@/features/assessments/consent/ConsentForm";
type ConsentItemProp = {
  type: string;
  label: string;
  required: boolean;
};
type ConsentOverlayProps = {
  open: boolean;
  consentChecked: boolean;
  isVerifying: boolean;
  translationKeys?: Partial<ConsentFormTranslationKeys>;
  biometricConsentItems?: ConsentItemProp[];
  onOpenChange: (open: boolean) => void;
  onConsentChange: (checked: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
};
export function ConsentOverlay(t0) {
  const $ = _c(20);
  const {
    open,
    consentChecked,
    isVerifying,
    translationKeys,
    biometricConsentItems,
    onOpenChange,
    onConsentChange,
    onCancel,
    onConfirm
  } = t0;
  const {
    t
  } = useTranslation();
  const t1 = translationKeys?.title ?? "assessmentSteps.studioSession.consent.title";
  let t2;
  if ($[0] !== t || $[1] !== t1) {
    t2 = t(t1);
    $[0] = t;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <ResponsiveModalTitle asChild={true}><span className="sr-only">{t2}</span></ResponsiveModalTitle>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== biometricConsentItems || $[6] !== consentChecked || $[7] !== isVerifying || $[8] !== onCancel || $[9] !== onConfirm || $[10] !== onConsentChange || $[11] !== translationKeys) {
    t4 = <ConsentForm biometricConsentItems={biometricConsentItems} consentChecked={consentChecked} isVerifying={isVerifying} translationKeys={translationKeys} onCancel={onCancel} onConfirm={onConfirm} onConsentChange={onConsentChange} />;
    $[5] = biometricConsentItems;
    $[6] = consentChecked;
    $[7] = isVerifying;
    $[8] = onCancel;
    $[9] = onConfirm;
    $[10] = onConsentChange;
    $[11] = translationKeys;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <ResponsiveModalContent className="max-h-[calc(100dvh-2rem)] overflow-y-auto [padding-bottom:calc(env(safe-area-inset-bottom)+1.5rem)]" dismissOnOutsideInteract={false} drawerClassName="px-4 py-8">{t3}{t4}</ResponsiveModalContent>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== onOpenChange || $[17] !== open || $[18] !== t5) {
    t6 = <ResponsiveModal mobileVariant="modal" open={open} onOpenChange={onOpenChange}>{t5}</ResponsiveModal>;
    $[16] = onOpenChange;
    $[17] = open;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}